module.exports = __webpack_public_path__ + "public/images/mastering-math.2993e1d047c3f14f32342c3b4030050a.jpg";